import y from "./setRafTimeout.js";
function f(t) {
  "@babel/helpers - typeof";
  return f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, f(t);
}
function p(t) {
  return h(t) || d(t) || m(t) || s();
}
function s() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function m(t, r) {
  if (t) {
    if (typeof t == "string") return b(t, r);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return b(t, r);
  }
}
function b(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, u = new Array(r); n < r; n++) u[n] = t[n];
  return u;
}
function d(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function h(t) {
  if (Array.isArray(t)) return t;
}
function S() {
  var t = {}, r = function() {
    return null;
  }, n = !1, u = function o(e) {
    if (!n) {
      if (Array.isArray(e)) {
        if (!e.length)
          return;
        var i = e, l = p(i), a = l[0], c = l.slice(1);
        if (typeof a == "number") {
          y(o.bind(null, c), a);
          return;
        }
        o(a), y(o.bind(null, c));
        return;
      }
      f(e) === "object" && (t = e, r(t)), typeof e == "function" && e();
    }
  };
  return {
    stop: function() {
      n = !0;
    },
    start: function(e) {
      n = !1, u(e);
    },
    subscribe: function(e) {
      return r = e, function() {
        r = function() {
          return null;
        };
      };
    }
  };
}
export {
  S as default
};
